var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWK(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.763 35.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.082-5.234)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "miter"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 11.63v-5.63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20 8h5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5 25c0 0 4.5-7.5 3-10.5 0 0-1-2.5-3-2.5-2 0-3 2.5-3 2.5-1.5 3 3 10.5 3 10.5",
    fill: "#fff",
    strokeLinecap: "butt"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 37c5.5 3.5 15.5 3.5 21 0v-7c0 0 9-4.5 6-10.5-4-6.5-13.5-3.5-16 4v3.5-3.5c-3.5-7.5-13-10.5-16-4-3 6 5 10 5 10v7.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 30c5.5-3 15.5-3 21 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 33.5c5.5-3 15.5-3 21 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.5 37c5.5-3 15.5-3 21 0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWK);
export default __webpack_public_path__ + "static/media/wK.0d914520ce0f3ec1b0aaddbdf71fad45.svg";
export { ForwardRef as ReactComponent };